import React from 'react';
import { trackEvent } from '../utils/analytics';
import { ANALYTICS_EVENTS } from '../utils/analyticsEvents';
import partners from '../data/partners.json';

export default function PartnersStrip({ title = 'Collaborations', subtitle = 'Trusted by brands and community partners' }) {
  return (
    <section className="px-6 pb-16">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-8">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-[#7b7671]">{title}</p>
            <h2 className="font-display text-3xl md:text-4xl text-[#1c1b1a] mt-3">Partners & collaborations</h2>
          </div>
          <p className="text-[#6a6661] max-w-md">{subtitle}</p>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.link}
              onClick={() => trackEvent(ANALYTICS_EVENTS.PARTNER_CLICK, { partner: partner.name })}
              target="_blank"
              rel="sponsored noopener noreferrer"
              className="border border-stone-200 bg-white/70 p-5 hover:border-[#bdb7b0] transition-colors"
            >
              <img src={partner.logo} alt={`${partner.name} logo`} className="w-full h-28 object-contain" />
              <div className="mt-4">
                <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">{partner.role}</p>
                <h3 className="font-display text-2xl text-[#2d2b29] mt-2">{partner.name}</h3>
                <p className="text-[#6a6661] mt-2">{partner.summary}</p>
              </div>
            </a>
          ))}
        </div>
        <div className="grid gap-6 md:grid-cols-2 mt-10">
          <div className="border border-stone-200 bg-[#f5f4f2] p-6">
            <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Lemfi offer</p>
            <h3 className="font-display text-2xl text-[#2d2b29] mt-3">Get €15 free with Lemfi</h3>
            <p className="text-[#6a6661] mt-3">
              I’m proud to partner with Lemfi. Download the Lemfi app and sign up with my referral code
              <strong className="text-[#2d2b29]"> sistakyerewaa </strong>
              to get €15 free. Fast, reliable transfers made easy for our community.
            </p>
            <a
              href="https://referral.lemfi.com/WCZBWMjlQ1b"
              onClick={() => trackEvent(ANALYTICS_EVENTS.PARTNER_CLICK, { partner: 'lemfi' })}
              target="_blank"
              rel="sponsored noopener noreferrer"
              className="inline-flex items-center justify-center mt-5 px-6 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
            >
              Learn more
            </a>
          </div>
          <div className="border border-stone-200 bg-[#f5f4f2] p-6">
            <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Learn Deutsch GH offer</p>
            <h3 className="font-display text-2xl text-[#2d2b29] mt-3">Get 300 cedis free in Ghana</h3>
            <p className="text-[#6a6661] mt-3">
              Register with Learn Deutsch GH using my referral code
              <strong className="text-[#2d2b29]"> sistakyerewaa </strong>
              and receive 300 cedis free. Locations: Accra and Kumasi.
            </p>
            <a
              href="https://learndeutsch24.com/"
              onClick={() => trackEvent(ANALYTICS_EVENTS.PARTNER_CLICK, { partner: 'learn_deutsch_gh' })}
              target="_blank"
              rel="sponsored noopener noreferrer"
              className="inline-flex items-center justify-center mt-5 px-6 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
